import React from "react";
import { Button, Card } from "flowbite-react";

const ErrorComponent = (props) => {
  const {
    membership = "Membership",
    memberServiceLink = "#",
    onClick = () => window.location.reload(),
    errorMessage = "It doesn't happen very often, but a technical problem prevented the payment from going through. Can you try again a little later?",
    languages,
  } = props;
  return (
    <div className="rounded-none flex flex-col justify-center bg-white px-24 py-8 mt-8 xs:p-4">
      <div className="flex flex-col">
        <h3 className="text-sm font-medium font-inter tracking-wider uppercase  text-center text-[#557B97]">
          {languages && languages.your ? languages.your : "Your"} {membership}
        </h3>
        <div className="flex justify-center my-8">
          {/* <img src={successIcon} alt='success-register-accorplus' className='w-[96px] h-[96px]' /> */}
          <svg
            class="w-[96px] h-[96px] text-[#221B1A] dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="96"
            height="96"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              fill-rule="evenodd"
              d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm5.757-1a1 1 0 1 0 0 2h8.486a1 1 0 1 0 0-2H7.757Z"
              clip-rule="evenodd"
            />
          </svg>
        </div>
        <p className="text-xl font-bold font-inter text-center">
          {languages && languages.errorBoxDescription
            ? languages.errorBoxDescription
            : "This is annoying..."}
        </p>
      </div>
      <p className="mt-4 font-medium text-lg text-[#221B1A] text-center font-montserrat px-24 xs:px-1">
        {errorMessage}
      </p>

      <div className="flex flex-col justify-center items-center mx-auto xs:items-stretch">
        <div className="mt-4 xs:mt-20">
          <button
            onClick={onClick}
            className="mt-4 p-2 btn-outline-blue rounded-sm shadow-md xs:mt-20 xs:w-full"
          >
            <span className="px-16 xs:px-8 uppercase font-inter font-medium text-lg">
              {languages && languages.errorBoxButton
                ? languages.errorBoxButton
                : "TRY AGAIN"}
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorComponent;
